import { Link } from 'react-router'
import { SEGMENTED_CONTROL_CLASS } from '@/components/SegmentedControl'
import {
  SegmentedIndicator,
  segmentedOptionClassName,
} from '@/components/SegmentedIndicator'
import { TabsList, TabsTrigger } from '@/components/ui/tabs'
import { cn } from '@/lib/utils'
import { useTrackerHref } from '@/provider/useTrackerHref'
import type {
  SiteHealthReportTab,
  SiteHealthReportTabsProps,
} from './siteHealthComponents.types'

// The Radix trigger keeps tab semantics and arrow-key focus; the segmented classes make it look like every other mode switch.
const VIEW_INDICATOR = 'site-health-report-view-indicator'
const TABS: readonly SiteHealthReportTab[] = [
  { view: 'overview', label: 'Overview' },
  { view: 'pages', label: 'By page' },
  { view: 'finding-types', label: 'By finding type' },
]
const TRIGGER_RESET_CLASS =
  'h-full flex-none border-0 py-0 data-[state=active]:bg-transparent data-[state=active]:text-foreground data-[state=active]:shadow-none'

export default function SiteHealthReportTabs({
  activeView,
  auditId,
  onViewChange,
  className,
}: SiteHealthReportTabsProps) {
  const href = useTrackerHref()

  return (
    <TabsList
      aria-label="Site Health report views"
      className={cn(SEGMENTED_CONTROL_CLASS, 'max-w-full', className)}
    >
      {TABS.map((tab) => {
        const active = activeView === tab.view

        return (
          <TabsTrigger key={tab.view} value={tab.view} asChild>
            <Link
              to={href(`/site-health/${auditId}?view=${tab.view}`)}
              aria-current={active ? 'page' : undefined}
              onClick={() => onViewChange(tab.view)}
              className={cn(
                segmentedOptionClassName(active),
                TRIGGER_RESET_CLASS
              )}
            >
              {active && <SegmentedIndicator layoutId={VIEW_INDICATOR} />}
              <span className="relative">{tab.label}</span>
            </Link>
          </TabsTrigger>
        )
      })}
    </TabsList>
  )
}
